import React from 'react';
import { Box, Dialog, IconButton } from '@material-ui/core';
import { Fullscreen, FullscreenExit } from '@material-ui/icons';
import { useCampfireTheme } from '../../../theme/useCampfireTheme';

interface ExpandablePanelProps {
  expanded: boolean;
  onCollapse: () => void;
  children: React.ReactNode;
}

export const ExpandablePanel = ({ expanded, onCollapse, children }: ExpandablePanelProps) =>
  expanded ? (
    <Dialog
      open
      onClose={onCollapse}
      maxWidth={false}
      PaperProps={{
        style: {
          width: '90vw',
          height: '90vh',
          maxWidth: '90vw',
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {children}
    </Dialog>
  ) : (
    <Box
      width={620}
      flexShrink={0}
      display='flex'
      flexDirection='column'
      minHeight={0}
      style={{ borderLeft: '1px solid #EFEFEF' }}
    >
      {children}
    </Box>
  );

interface ExpandToggleButtonProps {
  expanded: boolean;
  onToggle: () => void;
}

export const ExpandToggleButton = ({ expanded, onToggle }: ExpandToggleButtonProps) => {
  const { theme } = useCampfireTheme();
  const iconStyle = { fontSize: '20px', color: theme.color.grey.neutral300 };

  return (
    <IconButton
      size='small'
      onClick={onToggle}
      style={{
        width: 35,
        height: 35,
        boxSizing: 'border-box',
        padding: '4px',
        border: `1px solid ${theme.color.grey.neutral200}`,
        borderRadius: '4px',
        backgroundColor: 'white',
      }}
      title={expanded ? 'Collapse View' : 'Expand View'}
    >
      {expanded ? <FullscreenExit style={iconStyle} /> : <Fullscreen style={iconStyle} />}
    </IconButton>
  );
};
